import React from 'react';

import InfoTable from 'buyside/components/presentation/IdeaShowPage/InfoTable/infoTable';
import WhitePaperShowPageSubcategory from 'buyside/components/presentation/WhitePaper/ShowPage/Categories/Subcategory/WhitePaperShowPageSubcategory';

import { WhitePaperShowPageQuery } from 'interfaces/graphql-typings';
import { FollowableType } from 'buyside/components/presentation/FollowButton/followButton';

import styles from './styles.scss';

const WhitePaperShowPageCategories: React.FC<{
  sectors: NonNullable<WhitePaperShowPageQuery['whitePaper']>['sectors'];
  geographies: NonNullable<WhitePaperShowPageQuery['whitePaper']>['geographies'];
  esgs: NonNullable<WhitePaperShowPageQuery['whitePaper']>['esgs'];
  globalMacros: NonNullable<WhitePaperShowPageQuery['whitePaper']>['globalMacros'];
}> = ({ sectors, geographies, esgs, globalMacros }) => {
  return (
    <InfoTable title="Categories">
      {({ dataStyle, labelStyle }): React.ReactElement => (
        <>
          {Boolean(sectors?.length) && (
            <div className={styles.category}>
              <span className={labelStyle}>Sectors</span>
              <div className={dataStyle}>
                {sectors?.map(({ id, name }) => {
                  return (
                    <WhitePaperShowPageSubcategory
                      id={id}
                      key={name}
                      name={name}
                      category={FollowableType.SECTOR}
                    />
                  );
                })}
              </div>
            </div>
          )}
          {Boolean(geographies?.length) && (
            <div className={styles.category}>
              <span className={labelStyle}>Geographies</span>
              <div className={dataStyle}>
                {geographies?.map(({ id, name }) => {
                  return (
                    <WhitePaperShowPageSubcategory
                      id={id}
                      key={name}
                      name={name}
                      category={FollowableType.GEOGRAPHY}
                    />
                  );
                })}
              </div>
            </div>
          )}
          {Boolean(globalMacros?.length) && (
            <div className={styles.category}>
              <span className={labelStyle}>Global Macro</span>
              <div className={dataStyle}>
                {globalMacros?.map(({ id, name }) => {
                  return (
                    <WhitePaperShowPageSubcategory
                      id={id}
                      key={name}
                      name={name}
                      category={FollowableType.GLOBAL_MACRO}
                    />
                  );
                })}
              </div>
            </div>
          )}
          {Boolean(esgs?.length) && (
            <div className={styles.category}>
              <span className={labelStyle}>ESG</span>
              <div className={dataStyle}>
                {esgs?.map(({ id, name }) => {
                  return (
                    <WhitePaperShowPageSubcategory
                      id={id}
                      key={name}
                      name={name}
                      category={FollowableType.ESG}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}
    </InfoTable>
  );
};
export default WhitePaperShowPageCategories;
